interface Props {
  url: string;
  setUrl: (v: string) => void;
  pitch: string;
  setPitch: (v: string) => void;
  model: string;
  setModel: (v: string) => void;
  stage: string;
  setStage: (v: string) => void;
  onRun: () => void;
  onBack: () => void;
  cta: string;
}

const MODELS = ["B2B", "B2C", "B2B2C"] as const;
const STAGES = ["Pre-launch", "Just launched", "Growing"] as const;

export function AnalyzeGame({ url, setUrl, pitch, setPitch, model, setModel, stage, setStage, onRun, onBack, cta }: Props) {
  const valid = url.trim().length > 2;

  return (
    <div className="ganalyze screen-enter">
      <div className="wrap ganalyze-inner">
        <button className="gbtn ganalyze-back" onClick={onBack}>&larr; Back</button>

        <div className="ganalyze-head pop">
          <span className="pill pill--yellow">Set up your run</span>
          <h2 className="gdisplay ganalyze-h2">Tell me what I'm looking at.</h2>
          <p className="soft ganalyze-lead">
            Only the URL is required. Add the rest and the scoring gets sharper.
            Skip it and I'll infer the rest (and judge you for being vague).
          </p>
        </div>

        <div className="ganalyze-grid">
          <div className="gcard ganalyze-card pop" style={{ animationDelay: ".06s" }}>
            <label className="glabel ganalyze-label">
              <span className="gpixel ganalyze-step">01</span> Your URL
            </label>
            <div className="ganalyze-url">
              <span className="ghero-proto gpixel">URL</span>
              <input
                className="ghero-field"
                type="text"
                autoComplete="off"
                spellCheck={false}
                placeholder="yourstartup.com"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
              />
            </div>
          </div>

          <div className="gcard ganalyze-card pop" style={{ animationDelay: ".12s" }}>
            <label className="glabel ganalyze-label">
              <span className="gpixel ganalyze-step">02</span> Your claim <span className="faint">(this is the fun one)</span>
            </label>
            <p className="soft ganalyze-claim-help">
              In one or two sentences: what is this, and who is it for? I check it against your live site and call out the gap.
            </p>
            <textarea
              className="gfield"
              rows={3}
              placeholder="e.g. Back-office automation for small ops teams who can't afford an ops hire."
              value={pitch}
              onChange={(e) => setPitch(e.target.value)}
            />
          </div>

          <div className="ganalyze-optionals">
            <div className="gcard ganalyze-card pop" style={{ animationDelay: ".18s" }}>
              <label className="glabel ganalyze-label">Business model <span className="faint">(optional)</span></label>
              <div className="ganalyze-chips">
                {MODELS.map((m) => (
                  <button key={m} className="gchip" aria-pressed={model === m} onClick={() => setModel(model === m ? "" : m)}>
                    {m}
                  </button>
                ))}
              </div>
            </div>
            <div className="gcard ganalyze-card pop" style={{ animationDelay: ".22s" }}>
              <label className="glabel ganalyze-label">Stage <span className="faint">(optional)</span></label>
              <div className="ganalyze-chips">
                {STAGES.map((s) => (
                  <button key={s} className="gchip" aria-pressed={stage === s} onClick={() => setStage(stage === s ? "" : s)}>
                    {s}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="ganalyze-run pop" style={{ animationDelay: ".28s" }}>
          <button className="gbtn gbtn--primary gbtn--lg" disabled={!valid} onClick={onRun}>
            {cta} <span aria-hidden="true">&rarr;</span>
          </button>
          <p className="glabel ganalyze-run-note">No login. No "we'll email your results." Press the button. Get judged.</p>
        </div>
      </div>
    </div>
  );
}
